import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  getZone (obj, header, success, error) {
    Vue.axios.post(URL + 'homezone/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getOverDue (obj, header, success, error) { // ค้างชำระ Status=0 ค้างรับชำระ , =1 รับชำระแล้ว
    Vue.axios.post(URL + 'reports/invoices', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceive (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/receivedashboard', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getExpend (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/expenses', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDiff (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/sumexpenseandreceive', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDiffMonth (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/sumexpenseandreceiveBymonth', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getHome (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/homes', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getInvoice (obj, header, success, error) { // ค้างชำระ Status=0 ค้างรับชำระ , =1 รับชำระแล้ว
    Vue.axios.post(URL + 'reports/amountpayment', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getIncomeUser (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/receivebyuser', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReportoverdue (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/overdue', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReportsumoverdue (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/sumoverdue', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReportreceivedetail (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/receivedetail', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceivebygroup (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/receivebygroup', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getWaterReport (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/watarincome', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getCompareDetail (obj, header, success, error) {
    Vue.axios.post(URL + 'reports/DetailExpenseAndReceiveBymonth', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_report.js